import components from './components'
import data from './data'
import props from './props'
import methods from './methods'

export default {
  data,
  components,
  props,
  methods
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/item/resources/index.js